<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <div>
        <v-slide-x-transition mode="out-in">
          <v-tooltip
            v-if="isButton && (!value || !value.length)"
            key="button"
            bottom
          >
            <template v-slot:activator="{ on, attr }">
              <div class="w-fit" v-bind="attr" @click="dialog = true" v-on="on">
                <slot name="button">
                  <v-btn fab small v-bind="$attrs">
                    <v-icon>mdi-crosshairs</v-icon>
                  </v-btn>
                </slot>
              </div>
            </template>

            <span>{{ $t("userpicker.select_user") }}</span>
          </v-tooltip>

          <div v-else @click="dialog = true">
            <slot name="input">
              <div class="rowinfo">
                <v-text-field
                  key="field"
                  ref="input"
                  :error-messages="errors"
                  :value="displayValue"
                  append-icon="mdi-crosshairs"
                  class="cursor-pointer rounded-lg contentinfo"
                  clear-icon="mdi-close-circle-outline"
                  clearable
                  dense
                  hide-details
                  :label="$t('userpicker.choice_users')"
                  outlined
                  readonly
                  @click:clear="clearFilter"
                />
                <help-info
                  :element-name="`${serviceName}-${componentName}-selectedusers-name`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  :label="$t('userpicker.choice_users')"
                />
              </div>
            </slot>
          </div>
        </v-slide-x-transition>

        <custom-popup v-model="dialog" :cons="cons" max-width="800px">
          <v-card :loading="loading" class="transparent pa-4" flat>
            <vue-table
              v-model="tempSelection"
              :data="userInfo"
              :headers="headers"
              :loading.sync="loading"
              item-key="id"
              show-select
              @change="onPagination"
            >
              <template v-slot:filters="{ perPage, props }">
                <v-row no-gutters>
                  <v-col class="pa-2" cols="12" md="4" sm="6">
                    <v-select
                      v-model="props.length"
                      :items="perPage"
                      dense
                      hide-details
                      outlined
                    />
                  </v-col>

                  <v-col class="pa-2" cols="12" md="4" sm="6">
                    <v-text-field
                      v-model="props.search"
                      append-icon="mdi-magnify"
                      clear-icon="mdi-close-circle-outline"
                      clearable
                      dense
                      hide-details
                      :label="$t('search')"
                      outlined
                    />
                  </v-col>
                </v-row>
              </template>

              <template v-slot:created_at="{ item }">
                {{ datetime(item.created_at, "datetime") }}
              </template>
            </vue-table>
          </v-card>
        </custom-popup>
      </div>
    </template>
  </help-info-wrapper>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "personalUserPicker",

  props: {
    value: Array,
    errors: [Array, String],
    returnKey: {
      type: [String, Boolean],
      default: "id",
    },
    isButton: Boolean,
  },

  data() {
    return {
      helpData: [],
      componentName: "personalUserPicker",
      serviceName: "Qrland",
      dialog: false,
      tableProps: {
        page: 1,
        length: 10,
      },
      loading: false,
      userInfo: {},

      tempSelection: [],
    };
  },

  created() {
    this.getUserInfo();
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    ...mapState("localstorage", ["createQrID"]),
    cons() {
      return {
        title: this.$t("choice_users"),
        buttons: [{ type: "submit", handler: this.confirm }],
      };
    },

    headers() {
      return [
        {
          value: "id",
          text: this.$t("userpicker.id"),
          sortable: false,
          align: "center",
        },
        {
          value: "name",
          text: this.$t("name_field"),
          sortable: false,
          align: "center",
        },
        {
          value: "family",
          text: this.$t("family_name"),
          sortable: false,
          align: "center",
        },
        {
          value: "username",
          text: this.$t("username"),
          sortable: false,
          align: "center",
        },
        {
          value: "mobile",
          text: this.$t("userpicker.phone_number"),
          sortable: false,
          align: "center",
        },
        {
          value: "created_at",
          text: this.$t("userpicker.date_created"),
          sortable: false,
          align: "center",
        },
      ];
    },
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    displayValue() {
      return this.value
        ?.map((item) =>
          typeof item === "object" && Object.hasOwn(item, "id") ? item.id : item
        )
        .join(", ");
    },
  },

  watch: {
    dialog(val) {
      if (!!val) {
        this.getUserInfo();
      }
    },
  },

  methods: {
    getUserInfo(params = this.tableProps) {
      this.loading = true;

      this.$api
        .get("/v1/testQr/find-users", {
          params: {
            ...params,
            qr_id: this.createQrID,
          },
        })
        .then(({ data }) => {
          window.scrollTo({ behavior: "smooth", top: 0, left: 0 });

          this.userInfo = data;

          this.tempSelection = this.value?.map((item) =>
            typeof item === "object" && Object.hasOwn(item, "id")
              ? item
              : { id: item }
          );
        })
        .finally(() => (this.loading = false));
    },
    confirm() {
      this.computedValue = !!this.returnKey
        ? this.tempSelection?.map((item) => item.id)
        : this.tempSelection;

      this.$nextTick(() => {
        this.$emit("confirm");
      });
      this.dialog = false;
    },
    clearFilter() {
      this.$nextTick(() => {
        this.$emit("input", []);
        this.reloadTable();
        setTimeout(() => {
          this.$emit("confirm");
        }, 100);
      });
    },
    onPagination(e) {
      this.tableProps = e;
      this.$nextTick(() => {
        this.getUserInfo();
      });
    },
    reloadTable(params) {
      this.getUserInfo(params);
    },
    edit(data) {
      this.$router.push({ name: "admin.user.edit", params: { id: data.id } });
    },
    information(data) {
      this.$router.push({
        name: "admin.users.information",
        params: { id: data.id },
      });
    },
  },
};
</script>

<style scoped>
.w-fit {
  width: fit-content;
}
</style>
